<template>
  <div class="u-wrap">
    <div class="card">
      <van-form>
        <van-cell :title="model.address">
          <van-icon name="location" color="#1777FF" slot="icon" style="margin-top: 5px; margin-right: 5px" />
        </van-cell>
       <!-- <van-field
          :required="false"
          readonly
          clickable
          name="area"
          :value="wxTypeName"
          label="选择类别:"
          input-align="right"
          placeholder="请选择"
          @click="show = true"
          right-icon="arrow-down"
        />
        <div v-show="model.wxType">
          <van-cell :required="true" title="请选择分类" value="" :border="false" />
          <u-checkbox ref="checkBox" style="padding: 0 12px" @change="onChange"></u-checkbox>
        </div> -->
        <van-cell class="van-cell--required"  title="详细内容" value="" :border="false" />
        <textarea placeholder="请填写详细内容" class="xxnr" v-model="model.remark"></textarea>
        <div class="tips">
          温馨提示:
          <span class="tip"> 1、您可通过语音、文字、图片、视频等方式进行反馈。<br />2、带*为必填选项，方可提交。</span>
        </div>
        <van-action-sheet
          v-model="show"
          :actions="actions"
          @select="onSelect"
          close-on-click-action
          cancel-text="取消"
        />
      </van-form>
    </div>
      <div v-if="voiceList.length>0" class="voice-list">
      <div class="title">语音</div>
      <div class="audio" v-for="(item,index) in voiceList" :key="index">
         <div class="yuyin" :style="{width:(100+item.length*3)+'px'}" @click="playVoice(index)">
									<div v-if="item.play"  class="icon_audio_playing"></div>
										<div v-else class="icon_audio_default"></div> 
										<span  style="color: #FFFFFF;font-size: 14px;margin-left: 5px;">{{item.length}} "</span>
					</div> 
         <img  @click="deleteVoice(index)" src="@images/delete.png" style="width: 20px;height: 20px;margin-left: 10px;" />
      </div>
    </div>
    <div class="imgList" v-if="imgPathList.length > 0">
      <div class="title">图片</div>
      <div class="pre-box">
        <div class="pre-item" v-for="(item, index) in imgPathList" :key="index" >
          <img class="pre-item-image" :src="item"  @click="preImage(index,imgPathList)" />
          <div class="u-delete-icon" @click="deleteImage(index)">
            <img src="@images/delete.png" style="width: 24px; height: 24px" />
          </div>
        </div>
      </div>
    </div>
    <div class="video-p" v-if="videoPathList.length > 0">
      <div class="title">视频</div>
      <div v-for="(item, i) in videoPathList" :key="i" style="position: relative; display: inline-block">
        <video ref="video" :id="'myVideos' + i" class="video-js vjs-default-skin vjs-big-play-centered mt10">
          <source :src="item" type="video/mp4" />
        </video>
        <!-- <div class="u-delete-icon" @click="deleteVideo(i)">
            <img src="@images/delete.png" style="width: 24px; height: 24px" />
          </div>  -->
      </div>
    </div>

    <div class="b-btn">
      <button class="b-button" :disabled="disable" @click="onSumbit">提交</button>
    </div>

    <div class="sjcl-bottom input-box" :class="popupLayerClass" @touchmove.stop.prevent="discard">
      <img src="@images/people/audio2.png" style="width: 30px; height: 30px" />
      <div
        class="voice-mode cssSelect"
        :class="[recording ? 'recording' : '']"
        @touchstart="voiceBegin"
        @touchmove.stop.prevent="voiceIng"
        @touchend="voiceEnd"
        @touchcancel="voiceCancel"
      >
        {{ voiceTis }}
      </div>
      <img src="@images/people/add.png" style="width: 30px; height: 30px; margin-left: 10px" @click="showMore" />
    </div>
    <div class="record" :class="recording ? '' : 'hidden'" style="z-index: 99">
      <div class="ing" :class="willStop ? 'hidden' : ''"><div class="icon luyin2"></div></div>
      <div class="cancel" :class="willStop ? '' : 'hidden'"><div class="icon chehui"></div></div>
      <div class="tis" :class="willStop ? 'change' : ''">{{ recordTis }}</div>
    </div>

    <div class="popup-layer" :class="popupLayerClass">
      <!-- 更多功能 相册-拍照-红包 -->
      <div class="more-layer" :class="{ hidden: hideMore }">
        <div class="list" style="padding-top: 5px; justify-content: center">
          <div class="box" @click="clickPz">
            <img style="width: 40px; height: 40px" src="@images/people/paizhao.png" />
            <span style="margin-top: 5px">视频</span>
            <input
              @change="fileChangeVideo($event)"
              type="file"
              id="upload_video"
              class="input"
              multiple
              accept="video/*"
            />
          </div>
          <div class="box" @click="clickXc">
            <img style="width: 40px; height: 40px" src="@images/people/xiangce.png" />
            <span style="margin-top: 5px">图片</span>
          </div>
          <input
            @change="fileChangeImage($event)"
            type="file"
            id="upload_image"
            class="input"
            multiple
            accept="image/*"
          />
        </div>
      </div>
    </div>
     <smrz-pop :show="showSmrz"></smrz-pop>
  </div>
</template>

<script>
import uCheckbox from '@/components/page/u-checkbox.vue'
import uSelect from '@/components/page/u-select.vue'
import { getAction, postAction } from '@/api/manage'
import smrzPop from '@/views/common/smrz-pop.vue'
import FileMixin from '@/views/common/mixins/file-mixin.js'
import OpenIdMixin from "@/views/common/mixins/openId-mixin.js";
import wx from 'weixin-js-sdk'
import { ImagePreview } from 'vant'
export default {
  mixins: [FileMixin,OpenIdMixin], // 使用mixin (在main.js注册全局组件)
  components: {
    uCheckbox,
    uSelect,
    smrzPop
  },
  setup() {
    // themeVars 内的值会被转换成对应 CSS 变量
    // 比如 sliderBarHeight 会转换成 `--van-slider-bar-height`
    const themeVars = {
      cellRightIconColor: '#f00',
    }

    return {
      themeVars,
    }
  },
  data() {
    return {
      show: false,
      model: {
        // wxType: '',
        // wxTypeItem: '',
		dataType:"jjqz",
        sjly: '03',
		eventType: '02',
        remark: '',
        fj: '',
        actice: 'sbgzh',
        address: '',
        longitude: '',
        latitude: '',
      },
      wxTypeName: '',
      wxTypeItemName: '',
      lxfsName: '',
      actions: [],
      // 抽屉参数
      popupLayerClass: '',
      // more参数
      hideMore: true,

      isVoice: true,
      voiceTis: '按住 说话',
      recordTis: '手指上滑 取消发送',
      recording: false,
      willStop: false,
      initPoint: {
        identifier: 0,
        Y: 0,
      },
      recordTimer: null,
      recordLength: 0,
      list: [],
      imgList: [],
      voiceList:[],
      showSmrz:false,
     
    }
  },
  created() {

      this.initOpenId().then(res=>{
       if(this.isSmrz()){
           this.initWxInfo()
           this.getAddress()
           this.initType() 
       }else{//弹出实名认证
          this.showSmrz = true;
       }
    }).catch(err=>{

    });
  
  },
  mounted() {
    document.oncontextmenu = function (e) {
      e.preventDefault()
    }
    this.initVideo()
  },
  computed: {
    disable() {
      let disable = true
      if (this.model.remark ) {
        disable = false
      }

      return disable
    },
  },
  methods: {
    //调用接口
    initWxInfo() {
      let urlHref = encodeURIComponent(window.location.href)
      let params = { url: urlHref }
      let url = `/sys/mlogin/get/jsdk?url=${urlHref}`
      postAction(url,params).then((res) => {
        if (res.success) {
          let obj = res.result
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: obj.appId, // 必填，公众号的唯一标识
            timestamp: obj.timestamp, // 必填，生成签名的时间戳
            nonceStr: obj.nonceStr, // 必填，生成签名的随机串
            signature: obj.signature, // 必填，签名，见附录1
            jsApiList: [
              'getLocation',
              'startRecord',
              'stopRecord',
              'onVoiceRecordEnd',
              'playVoice',
              'onVoicePlayEnd',
              'pauseVoice',
              'stopVoice',
              'uploadVoice',
              'downloadVoice',
            ],
          })
        }
      })
    },
    getAddress() {
      let _this = this
      wx.ready(() => {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，
        wx.getLocation({
          type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: (d) => {
            var latitude = d.latitude // 纬度，浮点数，范围为90 ~ -90
            var longitude = d.longitude // 经度，浮点数，范围为180 ~ -180。
            _this.model.longitude = longitude
            _this.model.latitude = latitude
            console.log(latitude + '==' + longitude)
            var latLng = new qq.maps.LatLng(d.latitude, d.longitude)
            getAddr.getAddress(latLng)
          },
          fail: (d) => {
            this.$toast('获取微信坐标位置失败，请点击右上角‘…’→刷新一下，谢谢配合！')
          },
        })
      })
      wx.error((err) => {
        console.log(error)
      })

      var getAddr = new qq.maps.Geocoder({
        complete: function (res) {
          // _this.address = res.detail
          // var allAddress = res.detail.addressComponents
          var address = res.detail.address
          _this.model.address = address
        },
      })
    },
    initType() {
      let params = { pcode: 'A09', async: false }
      getAction('/sys/category/loadTreeRoot', params).then((res) => {
        let list = res.result
        let arr = []
        for (let item of list) {
          let obj = { name: item.title, value: item.code }
          arr.push(obj)
        }
        this.list = list
        this.actions = arr
      })
    },
    onSumbit() {
      let url = '/zhshj/wghgridwork/add' 
      this.model.openId = this.$store.getters.openId || "o9DSW5SxshU8GasJL9wkxhEXg7gw"
      let arr = [...this.imgPathList, ...this.videoPathList]
      this.model.fj = arr.join(',')
        if(this.model.remark==""&&this.model.fj==""){
          return this.$toast('请输入详细内容或者选择图片')
        }

      postAction(url, this.model).then((res) => {
        if (res.success) {
          this.$router.replace({
            name: 'success',
          })
        } else {
          this.$toast(res.message)
        }
      })
    },
    onChange(item) {
      this.model.wxTypeItem = item.code
    },
    onSelect(item, index) {
      this.model.wxType = item.value
      this.wxTypeName = item.name
      this.model.wxTypeItem = ''
      let list = this.list[index].children
      list.map((obj) => {
        obj.text = obj.title
        obj.value = obj.code
        return obj
      })
      this.$refs.checkBox.set({
        type: 'radio', // 类型：单选框
        list: list,
      })
      this.show = false
    },
       // 录音开始
    voiceBegin(e) {
      let that = this;
      if (e.touches.length > 1) {
        return
      }
      this.initPoint.Y = e.touches[0].clientY
      this.initPoint.identifier = e.touches[0].identifier

     
      	wx.startRecord({
				success: function() {
           that.recordBegin(e);
				},
				cancel: function() {
					mui.toast('用户拒绝授权录音');
				}
			});
    },
    //录音开始UI效果
    recordBegin(e) {
      this.recording = true
      this.voiceTis = '松开 结束'
      this.recordLength = 0
      this.recordTimer = setInterval(() => {
        this.recordLength++
      }, 1000)
    },
    // 录音被打断
    voiceCancel() {
      this.recording = false
      this.voiceTis = '按住 说话'
      this.recordTis = '手指上滑 取消发送'
      this.willStop = true //不发送录音
      this.recordEnd();
    },
    // 录音中(判断是否触发上滑取消发送)
    voiceIng(e) {
      if (!this.recording) {
        return
      }
      let touche = e.touches[0]
      //上滑一个导航栏的高度触发上滑取消发送
      if (this.initPoint.Y - touche.clientY >= 80) {
        this.willStop = true
        this.recordTis = '松开手指 取消发送'
      } else {
        this.willStop = false
        this.recordTis = '手指上滑 取消发送'
      }
    },
    voiceEnd(e){
					if (!this.recording) {
						return;
					}
					this.recording = false;
					this.voiceTis = '按住 说话';
					this.recordTis = '手指上滑 取消发送';
					// this.RECORDER.stop(); //录音结束
					this.recordEnd();
					
				},
    // 结束录音
   	//录音结束(回调文件)
				recordEnd(e) {
					let self = this;
					clearInterval(this.recordTimer);
					// if (!this.willStop) {
					  wx.stopRecord({
					      success: res=> {
							  
							  if(!this.willStop){
								 let msg = {
								   	length: 0,
								   	url:res.localId
								   };
								   msg.length = this.recordLength;
									 this.voiceList.push(msg);
									 this.uploadVoice(res.localId); 
							  }else{
									console.log('取消发送录音');  
							  }
							  this.willStop = false;
					      }
					  });
			},
    uploadVoice(localId){
      	wx.uploadVoice({
						localId: localId, 
						isShowProgressTips: 1, // 默认为1，显示进度提示
						success: res=> {
							//把录音在微信服务器上的id（res.serverId）发送到自己的服务器供下载。
							// this.audioPathList.push(res.serverId);
              this.uploadAudio(res.serverId);
						}
					});
    },
    playVoice(index){
    let voiceId = this.voiceList[index].url;
					wx.playVoice({
					    localId: voiceId ,// 需要播放的音频的本地ID，由stopRecord接口获得
						success:respone=> {

						   }
					});
    },
     deleteVoice(index){
      	this.voiceList.splice(index,1);
				this.audioPathList.splice(index,1);
    },
    showMore() {
      if (this.hideMore) {
        this.hideMore = false
        this.openDrawer()
      } else {
        this.hideDrawer()
      }
    },
    openDrawer() {
      this.popupLayerClass = 'showLayer'
    },
    hideDrawer() {
      this.popupLayerClass = ''
      setTimeout(() => {
        this.hideMore = true
      }, 150)
    },
     preImage(index, imgList) {
      ImagePreview({
        images: imgList,
        startPosition: index,
      })
    },
  },
  beforeDestroy() {
    this.dispatchVideo()
  },
}
</script>

<style lang="less" scoped>
@import '../../assets/less/dialog.less';
.u-wrap {
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #f5f5f5;
  padding-bottom: 60px;
  padding-top: 12px;
}
.heard {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
}
.u-content-wrap {
  flex: 1;
  display: flex;
}

.card {
  background: #ffffff;
  padding: 0px;
  margin: 0 8px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  overflow: hidden;
  height: auto;
  margin-bottom: 12px;
}

.xxnr {
  width: 90%;
  margin: 0 12px;
  height: 128px;
  border-radius: 5px;
  border: 1px solid #ededed;
  padding: 8px;
  font-size: 14px;
}

.tips {
  padding: 12px;
  color: #999999;
  line-height: 18px;
  font-size: 12px;
  display: flex;
}

.tip {
  flex: 1;
  margin-left: 6px;
}

.sjcl-bottom {
  height: 60px;
  width: 96%;
  background: #ffffff;
  position: fixed;
  bottom: 0px;
  padding: 0px 10px;
  align-items: center;
  justify-content: center;
  display: flex;
  box-shadow: 0px -3px 8px 0px rgba(216, 216, 216, 0.5);
  .voice-mode {
    flex: 1;
    margin-left: 10px;
    height: 40px;
    font-size: 16px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(211, 211, 211, 1);
    border-radius: 5px;
    text-align: center;
    line-height: 40px;
  }
}

.b-btn {
  padding: 0 20px;
  margin-bottom: 20px;

  .b-button {
    width: 100%;
    height: 44px;
    background: #3f8ffb;
    border-radius: 5px;
    opacity: 1;
    border: none;
    color: #ffffff;
  }

  .b-button[disabled] {
    opacity: 0.48;
  }
}

.input {
  width: 80px;
  height: 80px;
  position: absolute;
  display: none;
}

.imgList .title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  padding-left: 12px;
}

.pre-box {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  padding: 12px;
}

.pre-item {
  /* flex: 0 0 48.5%; */
  border-radius: 5px;
  height: 80px;
  overflow: hidden;
  position: relative;
  /* margin-bottom: px; */
}
.u-progress {
  position: absolute;
  bottom: 5px;
  left: 4px;
  right: 4px;
  z-index: 9;
  width: auto;
}

.pre-item-image {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 8px;
  object-fit: cover;
}

.u-delete-icon {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 10;
  /* background-color: $u-type-error; */
  border-radius: 50px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-p {
  padding: 12px;
}

.video-class {
  margin-right: 10px;
  margin-bottom: 10px;
}

.title {
  line-height: 30px;
}

.cssSelect {
  //这里为css选择器
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none; /*用户是否能够选中文本*/
}

	.yuyin{
			width:100px;
			height:35px;
			background:#367EFF;
			border:1px solid rgba(211,211,211,1);
			border-radius:35px;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			padding-left: 10px;
		}
		.audio{
			display: flex;
			align-items: center;
			margin-bottom: 10px;
			
		}
		
		.icon_audio_default {
			background: transparent url('~@images/iconloop.png') no-repeat 0 0;
			width: 14px;
			height: 18px;
			vertical-align: middle;
			display: inline-block;
			-webkit-background-size: 42px 18px;
			background-size: 42px 18px;
			background-position: -28px center;
		}
		
		.icon_audio_playing {
			background: transparent url('~@images/iconloop.png') no-repeat 0 0;
			width: 14px;
			height: 18px;
			vertical-align: middle;
			display: inline-block;
			-webkit-background-size: 42px 18px;
			background-size: 42px 18px;
			-webkit-animation: audio_playing 1s infinite;
			background-position: 0px center;
		}
		
		
		@-webkit-keyframes audio_playing {
			30% {
				background-position: 0px center;
			}
		
			31% {
				background-position: -14px center;
			}
		
			61% {
				background-position: -14px center;
			}
		
			61.5% {
				background-position: -28px center;
			}
		
			100% {
				background-position: -28px center;
			}
		}

    .voice-list{
      padding-left: 12px;
      padding-bottom: 12px;
    }
</style>
